import { render, staticRenderFns } from "./DsbFooterColumn.vue?vue&type=template&id=bd95c88e"
import script from "./DsbFooterColumn.vue?vue&type=script&lang=js"
export * from "./DsbFooterColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports